import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import "./Jobs.scss";
const SkeletonJobs = () => {
  const jobList = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }];

  return (
    <>
      {jobList.map((item) => (
        <li className="job-data" key={item.id}>
          <Row className="justify-content-between">
            <Col>
              <span className="post-date">
                <Skeleton width={50} />
              </span>
            </Col>
            <Col xs="auto">
              <span className="job-ref">
                <Skeleton width={50} />
              </span>
            </Col>
          </Row>
          <div className="xs-heading">
            <span>
              <Skeleton width={250} />
            </span>
          </div>
          <ul className="job-data-highlights">
            <li>
              <span>
                <Skeleton width={150} />
              </span>
            </li>
            <li>
              <span>
                <Skeleton width={150} />
              </span>
            </li>
            <li>
              <span>
                <Skeleton width={150} />
              </span>
            </li>
          </ul>

          <Skeleton count={2} />
        </li>
      ))}
    </>
  );
};

export default SkeletonJobs;
